import { getCommissionsRepository } from "../Infrastructure/Commissions.repository";

export async function getCommissionsLogic(params) {
  return getCommissionsRepository(params);
}
